<template lang="pug">
v-container.sign-in
  v-layout.sign-in__form(row, wrap)
    v-card.pa-5(color="primary" dark flat min-width="420px")
      h2.mb-4.text-center Вход в систему
      v-text-field(
        v-model="form.username"
        filled
        placeholder="Имя"
        @keyup.enter="login"
      )
      password-input(v-model="form.password" filled label="Пароль")
      v-btn(
        :loading="loading"
        large
        block
        color="secondary"
        @click="login"
        @keyup.enter="login"
        :disabled="!form.username || !form.password"
      ) Войти
</template>
<script>
import authService from '@/services/API/auth';
import JWTService from '@/services/JWTService';
import { mapActions } from 'vuex';
import PasswordInput from '@/components/inputs/PasswordInput.vue';

export default {
  name: 'Login',
  components:{ PasswordInput },
  data() {
    return {
      form: {
        username: '',
        password: '',
      },
      loading: false,
    };
  },
  methods: {
    ...mapActions({
      init: 'auth/init',
    }),
    async login() {
      try {
        this.loading = true;
        const response = await authService.login(this.form);
        const { access_token, refresh_token } = response.data.data;

        JWTService.setToken(access_token);
        JWTService.setRefreshToken(refresh_token);

        await this.init();

        this.$router.push(this.$route.query.redirect || '/');
      } catch (err) {
        this.$toast.error(err?.response?.data?.data?.message);
      } finally {
        this.loading = false;
      }
    },
  },

};
</script>

<style lang="scss" scoped>
.sign-in {
  display: flex;
  height: 100%;

  &__form {
    justify-content: center;
    align-self: center;
  }
}
</style>
